import { Splashscreen } from '@/components/splashscreen/splashscreen';
import { buildAppDeepLink } from '@/lib/app-links';
import { isMobile } from '@/lib/platform';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Summary deep-link route.
 *
 * - Mobile browser: fires `allo://main/call-details?callId=<id>` to open the
 *   mobile app (allo:// is the registered scheme on iOS and Android).
 * - Everywhere else (desktop web, Electron): redirects to the inbox view
 *   with the summary panel open.
 *
 * The mobile-app launch and the web fallback both run on every render: if the
 * app opens, the browser tab is left behind on the inbox view (harmless); if
 * the app is not installed, the user just lands on the inbox view directly.
 */
export const Route = createFileRoute('/summary/$callId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { callId } = Route.useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile()) {
      window.location.href = buildAppDeepLink(
        `main/call-details?callId=${encodeURIComponent(callId)}`,
      );
    }

    void navigate({ to: '/', search: { callId, view: 'summaries' }, replace: true });
  }, [callId, navigate]);

  return <Splashscreen />;
}
